<template>
  <article class="app-article">
    <h2 id="part-1">生命晚期的不堪圖像</h2>
    <p>初秋的北海岸，天氣漸漸轉涼，老太太緩緩下了客運，走向十八王公廟。這天香客稀少，冷清蕭瑟，她喃喃自語祈禱後，往海堤走去，不久就消失不見人影。</p>
    <p>兩天後，她的遺體被海水打上岸，死因是生前落水。警方找不到遺體身份，又沒有家屬來認領，採集 DNA 留存後，編號 6546，葬在石門四號公墓。</p>
    <p>15 年後，板橋分局巡佐蔡淑女坐在辦公桌前，開始例行找尋失蹤人口。她鍵入關鍵字，螢幕跳出一個失蹤人口跟編號 6546 無名屍有些關聯。她眼睛在視窗間來回掃視推敲著，前者失蹤跟後者發現時間只差兩天，失蹤者沒去換發新身分證，10 幾年來，也沒有任何就醫資料，她覺得或許兩個是同個人，於是聯絡失蹤者的兒子蘇介席，問他是否願意進行 DNA 比對。</p>
    <p>當蔡淑女連絡上蘇介席，蘇介席還以為她是詐騙集團，蔡淑女好說歹說，蘇介席才走進板橋分局，經採集 DNA 後，確定跟無名屍是親子關係。</p>
    <p>16 年前母親失蹤後，蘇介席從鄰居親友家，到媽媽常去的醫院，再到十八王公廟找人，遍尋不著。每當夜深人靜，他常想，「媽媽為什麼走？」母親沒有任何異樣，但她 70 多歲了，老毛病很多，她曾說，「老啊，身體退化啊，就應該轉去啊。」他推測媽媽怕拖累他，當時他在大陸做生意，為了照顧她，奔波兩岸，兩個哥哥工作不穩定，一家經濟全靠他。母親失蹤半年後，蘇介席預感她已經不在人世了，每次經過廟裡就進去拜拜，他常念母親「要走也不說一下，你不想造成我的負擔，也不用這樣。」他遺憾母親連最後一程都不讓他送。</p>
    <p>開棺當天，蘇介席來到石門公墓，看著一片荒煙蔓草，仍懷疑「真的會是媽媽嗎？」除了檢察官跟法醫，蔡淑女找了善願協會會長郭志祥來幫忙。當開棺那一刻，蘇介席一看到假牙牙套，淚就流了下來，這是媽媽，媽媽一排牙掉了，裝了牙套，媽媽終於回來了。</p>
    <h3>如果可以善終，這悲劇就不會發生</h3>
    <p>郭志祥在一旁看了覺得很心酸，看蘇介席結束大陸生意，回台灣在當外送員，還有個 10 歲兒子要照顧，日子並不好過，他義務幫忙將他母親後事辦好。他感慨地說：「如果可以善終，這悲劇就不會發生。」蘇介席談到媽媽蘇郭冬瓜，嘆氣說：「我終於可以放下16年來對她的愧疚。我媽真的很勇敢，我一個人在養她，我爸走前，也是我一個人在照顧，她不要我繼續這樣子，她太愛我了。」</p>
    <p>「其實像蘇郭冬瓜這種人很多。」蔡淑女打開一個個檔案資料說，像賴先生因為工作傷到背，痛到難以忍受，某天跟老婆散步後就失蹤了，再找到已是 7 年後。另一個吳老太太不想拖累視障、在做按摩工作的兒子，走上絕路，找到是 11 年後。還有 50 歲的王先生罹患口腔癌末期，面對母親 78 歲，家中還有個中風的哥哥，他自殺了。蔡淑女說：「目前我處理上百例，超過一半都是像這樣久病厭世的。」</p>
    <p>隱藏在這些自殺案背後的，是人到生命末期，不得善終的苦境。</p>
    <p>高齡化在台灣是趨勢，如今每 7 個人就有一個年過 65 歲的老人，內政部預估 115 年，會達到每 5 個人就有一個老人。107 年國人平均壽命已超過 80 歲，平均健康餘命卻只有 71.2 歲，中間 9.5 年的差距，等於有近 10 年的老人生命是在不快樂、不健康跟不順遂的情況下度過，於是自殺老人年年增加。根據衛福部統計，年過 65 歲的老人自殺率一向高於其他年齡層。107 年，台灣自殺人口 3865 人，其中老人佔了四分之一，自殺死亡率為一般人的 2 倍。</p>
    <p>面對生命末期，現有的法律跟長照資源似乎幫不了這些人的忙，有人因而倡議「安樂死」。最引起注意的就是前體育主播傅達仁遠赴瑞士安樂死。前立委許毓仁曾提出《尊嚴善終法》草案，但今年初立委改選後全案因「屆期不連續」的規則作廢。今年 4 月，民眾黨重提此案，將在立院新會期討論。</p>
    <p>安樂死的英文 Euthanasia，源自希臘文 euthanatos 跟 euthanateo 兩個字，指快樂/舒適地死去，或有尊嚴的死去。延伸到現代的安樂死則意指，當一個無法痊癒的病人生活品質惡化，沒有生活自理能力，因應他的要求，採取較不痛苦的方式終止其生命。</p>
    <p>究竟什麼是安樂死？最早允許安樂死的國家荷蘭跟比利時，對申請安樂死終止生命的要件，除了病人的自主意願，還必須符合：</p>
    <p>第一，病人罹患醫學上無可治癒的疾病；<br>第二，醫師確定病人身體跟心理持續承受難以忍受或劇烈的痛苦；<br>第三，醫師與病人確定沒有其他合理的解決方法可改善病人的症狀。最後，必須諮詢另一位毫無利害關係的醫師。</p>
    <p>「我關注安樂死，是因為看到許多病人跟家屬在死亡之前這段歷程太痛苦了。但是，多數人看不到死亡前那些不堪，很少人會去思考面對生命末期的許多困難，社會到底要建立一個怎樣的制度跟法律？」臺北大學社會工作系教授曾敏傑說道。去年 11 月，他主持的社科院前瞻計畫與傅達仁創辦的「中華善終協會」合辦了一場安樂死研討會。曾敏傑提起傅達仁罹患胰臟癌末期時，來學校演講，傅達仁在台上直挺挺地站了 30 分鐘，中氣十足地把演講講完，但是一下台，就像洩氣般縮在那，痛苦不堪。安寧療護在當時並無法幫助傅達仁減輕太多痛苦，最後他選擇到瑞士安樂死。</p>
    <p>為什麼既有法律《安寧緩和醫療條例》和《病人自主權利法》，無法幫助像傅達仁這樣的病人，而需要遠赴瑞士，才能解決痛苦？</p>
    <h2 id="part-2">寧搭死亡快車</h2>
    <h3>許多病人跟家屬在死亡之前這段經歷太痛苦了</h3>
    <p>律師紀岳良今年 33 歲，在經歷阿嬤跟父親的痛苦死亡過程之後，積極投入推動安樂死立法。</p>
    <p>紀岳良說，阿嬤得到失智症1年多，合併罹患帕金森氏症，開始出現吞嚥困難，「我們那時候也沒想什麼，就讓阿嬤接鼻胃管，她臥床後，你大概可以想像她整個人就是變成身體蜷曲，一個槁木死灰的人⋯⋯她甚至不是個人，而像是個東西躺在那裡。」</p>
    <p>阿嬤臥床兩年多過世，紀岳良開始接觸安寧醫療。為了減輕或免除末期病人生理及心理的痛苦，安寧療護著重症狀控制，給予緩解性的醫療照護，臨終也不會刻意急救。紀岳良覺得如果當初讓阿嬤接受安寧照護，她就可以不用插管好好走。不久，紀岳良的阿公也因嚴重失智吞嚥困難，幸運的是他在家斷氣，沒有經歷像妻子那一段折磨。</p>
    <p>阿公阿嬤離世讓紀岳良開始思考，以後可不可以不要再經歷阿嬤後面那些事？兩年後，紀岳良的父親確診肝癌末期。剛開始，紀岳良的父親口服嗎啡，但是口乾舌燥、便秘，還會昏睡，意識變得不清楚，他吃沒多久就不願意吃了。紀岳良說父親跟他說「我不想要睡死」，之後嗎啡改用貼的，「但是也沒有改善這些副作用，他還是很痛，說身體有團火在燒。」</p>
    <img src="../assets/img_01.jpg" alt="陪伴父親臨終的痛苦經驗，紀岳良感受到，安寧療護無法解決所有病痛。" loading="lazy">
    <p class="figcaption">陪伴父親臨終的痛苦經驗，紀岳良感受到，安寧療護無法解決所有病痛。</p>
    <p>看父親這麼痛苦，紀岳良嘗試找醫院讓父親接受安寧照護，但是台中有安寧病房的醫院不多，有也只是病房看起來溫暖一點，其他跟一般病房差不多，沒有家人陪伴的空間。有醫院告訴他，重症病房有套房，但是一天要 1 萬塊，剛當律師的紀岳良覺得自己如果硬付，等父親走後大概也負債累累。</p>
    <p>最後時光，紀岳良的父親待在家，紀岳良說：「他營養不良，出現併發症，無法走路，連話都說不出來，已接近失能狀態。他曾痛到跟我媽說：『我什麼時候可以走？』他想早點解脫，如果那時台灣有安樂死的法律，我爸會選擇那條路。」紀岳良的父親不吃不喝幾天後，某天於夜裡斷氣，紀岳良慶幸父親從知道病情到死亡，不到 3 個月，沒拖太久。「我從我父親身上看到，安寧病房可以做一些事，但是不可能解決所有病痛。」</p>
    <p>許多癌末病人如紀岳良父親一樣，其住家附近未必有安寧病房，目前安寧制度也還是欠缺可親近性。根據衛福部資料，2010 年到 2015 年間，安寧醫療意願註記比例僅 1.4％，雖然這幾年註記人口有增加，但是比例還是很低；都會地區也比非都會地區高，顯示民眾難以使用。</p>
    <h3>痛在我身上，你們怎麼知道我的痛苦</h3>
    <p>傅達仁的太太鄭貽說，當初傅達仁一生病就有個想法，每個人生不能控制，最後的走可以操控在自己手上。當傅達仁決定向瑞士尊嚴協會申請安樂死時，家人根本無法接受，用各種方式推託，延遲申請。傅達仁為此數度跟家人發脾氣，「痛在我身上，你們怎麼知道我的痛苦？」到後來傅達仁沒有嗎啡根本無法做任何事，甚至得靠嗎啡才吃得下飯。他曾跟來家裡的安寧醫療團隊說，「如果可以吃得下飯，我當然活啊，如果連最基本的功能吃飯都失去了，那活著有什麼意思？」</p>
    <p>傅達仁第一次去瑞士，看家人沒有準備好，兒子傅俊豪又在瑞士生病，他不捨拋下家人決定返台，但是一回台灣就因嗎啡過敏送急診。一個 80 多歲的老人躺在病床上，24 小時不停的翻白眼，無意識的像做仰臥起坐一樣的躺下、起來，讓家人嚇壞了。但是傅達仁卻奇蹟似的醒來。這次瀕死經驗痛撤心肺，讓傅達仁更確定要去瑞士，選擇無痛離開。家人終於也接受了。傅俊豪說，「父親生我時已經 60 幾歲了，他從小就告訴我，爸爸有天ㄧ定會走。到晚年，他也常講『送君千里，終須一別。』看著他一天天衰弱，痛苦地過每一天，我逐漸被他說服。」</p>
    <img src="../assets/img_02.jpg" alt="傅俊豪與鄭貽母子看著傅達仁一天天衰弱，終於理解接納他的選擇。" loading="lazy">
    <p class="figcaption">傅俊豪與鄭貽母子看著傅達仁一天天衰弱，終於理解接納他的選擇。</p>
    <p>有醫師認為，傅達仁如果接受安寧療護，不吃不喝，經過止痛跟鎮靜，可以安詳的走，並不需要安樂死。但是傅俊豪說：「父親是安寧緩和醫療的病患，可是安寧醫療對他來說，很像坐慢車，先是止痛藥一顆、兩顆、三顆；後面是嗎啡，他從 1 週 1 瓶，到 3 天 1 瓶，沒有辦法有效止痛；嗎啡造成的暈眩也讓他很容易跌倒，因而更痛苦。當安寧醫療到了極限，我父親決定搭快車完成自己的善終。」</p>
    <h3>醫師照顧母親後，才瞭解照顧是件多麼辛苦的事</h3>
    <p>「如果有快車，為什麼要叫我搭慢車？」照顧母親的經驗，讓婦產科醫師江盛很認同傅達仁這句話。2017 年，江盛看到父親因為糖尿病跟洗腎，送急診的頻率越來越高，提早從馬偕醫院退休回家照顧父母親。沒想到回家第一個診斷的失智症患者是母親。</p>
    <p>「她後來癱瘓，整天喊痛，我們決定使用止痛藥，但是我覺得這個止痛藥是不夠的。我媽還長褥瘡，她只要坐輪椅 20 分鐘沒拉起來，壓迫皮膚就長出水泡。」江盛說，自己是外科醫師，就天天幫媽媽換藥，破皮 12 天就好了，但是水泡一下長這裡，一下長那裡，他就想盡辦法幫媽媽換姿勢。江盛嘆口氣說：「但是睡覺時，大家都沒力氣啊，半夜怎麼幫她翻身？以前在醫院看到病人長褥瘡，會覺得怎麼會照顧到這樣子？但是當我照顧母親後，才了解照顧是多麼辛苦的事。我媽最後好瘦，我充滿罪惡感，我是醫師耶，母親怎會被我照顧成這個樣子。所以，這些都很困難。」</p>
    <p>江盛的母親年輕時是護士，她曾叮嚀江盛，她以後不要插管。到後來，江盛跟母親的主治醫師討論，只讓媽媽打抗生素跟點滴，沒有給她進食。江盛說：「因為醫師的訓練，第 3 天我就知道她死定了，當時我曾想，我是第 4 天就讓我母親死，還是拖到第 14 天以後死，但是我想我媽應該不會希望我替她這樣做，因而入獄或變成一個新聞人物。」看母親這麼痛苦，江盛甚至曾檢討一定是自己愛母親不夠多，否則怎麼忍心她承受最後苦難的 11 天？</p>
    <p>江盛覺得，人的死亡變化有千百種、千萬種，安寧照顧不可能解決這一切。2018 年，他發起公投連署，希望安樂死作為一種臨終抉擇，能引起社會討論。</p>
    <h3>安樂死是加工死，對家屬跟醫師都是創痛</h3>
    <p>不過前衛生署長楊志良仍認為安寧照護和去年開始實施的《病人自主權利法》就可以解決末期病人痛苦的問題，不需要安樂死。根據《病主法》，病人擁有優先知道自己病情的權利，並且預立醫療決定，當生命來到末期，有權利拒絕一切可能延長生命的醫療與照顧，包括人工營養及管灌餵食。</p>
    <p>楊志良提起大他兩歲的哥哥，罹患大腸癌到後期，有天清醒，台北聯合醫院總院長黃勝堅剛好來看他，問他有什麼願望？楊志良的哥哥說，好想喝啤酒啊，很難想像在醫院可以喝酒，但是黃勝堅為了完成臨終病人遺願，於是找人去買了啤酒，讓楊志良陪著哥哥小酌。楊志良說：「隔兩天，我哥不吃不喝，在深度的鎮定底下走了。我當然不捨，但是這跟安樂死有什麼差別？只是安樂死更積極一點而已。」楊志良認為，如果傅達仁當時有《病主法》，他只要預先簽署，根本不需要去瑞士。</p>
    <img src="../assets/img_03.jpg" alt="楊志良認為，去年開始實施的《病人自主權利法》，就足以保障病人臨終的尊嚴與需求。" loading="lazy">
    <p class="figcaption">楊志良認為，去年開始實施的《病人自主權利法》，就足以保障病人臨終的尊嚴與需求。</p>
    <p>楊志良解釋，依《病主法》如果有「預立醫療決定」，當符合下面幾種條件，可以依病人意願執行，第一，末期病人，第二，處於不可逆轉的昏迷狀態；第三，永久植物人；第四，極重度失智，第五，其他經中央主管機關公告的 11 種疾病（包括小腦萎縮跟漸凍症等 10 種罕病跟 1 種疾病），或痛苦難以忍受。楊志良特別強調「痛苦難以忍受」的標準，「這不是醫師認為，是病人認為。」</p>
    <p>在執行病人意願方面，《病主法》規定必須當疾病無法治療，且依當時的醫療水準，沒有其他合適的方法解決，由兩位以上相關專科醫師確診，並經安寧緩和團隊至少兩次的照會確認，醫療機構或醫師依其意願來執行。</p>
    <p>楊志良說：「你看這範圍多廣，只要我有不可忍受的痛苦，這是主觀的，解釋是很寬的。所以我反對安樂死，安樂死是加工死，對家屬跟醫師都是心理上的創痛。但是，不要維生系統、自然死，執行的醫師跟家屬比較能接受。」</p>
    <p>目前反對安樂死最激烈的就是醫師團體，除了風險考量，還有過往醫學教育的訓練都是「救人救到底」，怎麼可能去「殺人」。</p>
    <h2 id="part-3">生命權跟死亡權的拉扯</h2>
    <h3>旁人覺得，我還有呼吸就該活著</h3>
    <p>什麼人需要安樂死？歸納 2016 年荷蘭跟比利時尋求安樂死的人罹患疾病種類，癌症最多，超過六成，另外就是神經系統、心血管跟呼吸系統疾病、老年症候群、認知症（亦即失智症）、合併多重疾病及精神疾病。江盛曾推估，台灣有安樂死需求的人，每年約有 2 千到 4 千人，但他們非老即病，難有力量發聲。</p>
    <AppLightbox :gaIndex="1" class="article__lightbox lazy">
      <template v-slot:lightboxImage>
        <img src="../assets/lightbox_btn_01.jpg" alt="溫金盛：我苦於我活著" loading="lazy">
      </template>
      <template v-slot:lightboxTitle>
        <span>我苦於我活著</span>
      </template>
      <template v-slot:lightboxSubtitle>
        <span>溫金盛</span>
      </template>
      <template v-slot:lightboxContent>
        <h2>溫金盛：我苦於我活著</h2>
        <div class="lightbox__image">
          <img data-src="/projects/they-all-request-for-euthanasia/lightbox_01.jpg" src="" alt="溫金盛：我苦於我活著">
          <p class="figcaption">24 年來，四面牆跟一個螢幕幾乎就是溫金盛全部世界。他說，做什麼事都要依賴人，無法自我實現，活得毫無意義。</p>
        </div>
        <p>車禍癱瘓 24 年來，溫金盛多半時間只能躺著。最近姊姊幫他買了移位機，他期待可以下床坐輪椅，出去曬曬太陽，看看天空。但是這幾天天氣又開始變化，車禍造成他的神經系統受損，身體無法調節體溫跟排汗，他不敢出門。又是一個意志消沈的一天。</p>
        <p>溫金盛父母早已分開，溫金盛受傷前 11 年，都是母親照顧，溫金盛的父親則在苗栗老家照顧失智症的母親。溫金盛剛受傷時，就知道脊髓損傷無法治療，他曾設底線，如果 10 年沒有好轉，就不想再撐了。</p>
        <p>溫金盛的母親開飲料店賺錢找外勞照顧他，姊姊後來在醫院當放射師，也每天輪兩班工作 16 小時，分擔母親的壓力，溫金盛說：「我媽撐得很累，看我姐這樣，也覺得對她不公平，她曾問我，『要不要一起走？』」生活將溫金盛磨到看不出情緒，但是一提起母親跟姊姊，他語氣流露感情。受傷 10 年後，溫金盛的肌肉萎縮，骨骼變形，全是不可逆的。而他母親因為太過操勞，不久腦溢血過世，走時才 40 多歲。照顧溫金盛的重擔改落在他父親手上。</p>
        <p>溫金盛回苗栗又 10 年過去了，如今他的心肺功能只剩三、四成，每天 24 小時忍受著全身像久坐腳麻的痛楚，最近又被診斷罹患糖尿病，但是最大的痛苦其實是生活完全無法自理。他苦惱地說：「我連手都不方便，只有肩膀能動，我做什麼都要開口叫人，有沒有尊嚴是其次，而是活著的意義，如果自己什麼都沒辦法做，活下來的意義是什麼？」</p>
        <p>溫金盛曾試著幫人打字想賺點錢，電腦是姊姊買的，溫金盛請外勞用一隻筷子黏一隻鉛筆，用嘴咬著它來操作滑鼠滾輪。但是他好不容易打完校好稿，對方卻消失了，讓溫金盛很沮喪，「如果我還能用電腦工作就還好，但是我沒辦法。我每天醒來就是追劇、看電腦，我這樣活著有什麼意義嗎？」不斷被網路餵食，溫金盛很空虛，當生命不能夢想，不能自我實現，對溫金盛是最大的懲罰。</p>
        <p>最讓溫金盛愧疚憂心的是，家快被他拖垮了。姊姊嫁人了，有自己的家要照顧，近幾年就靠父親種橘子跟溫金盛哥哥的薪水，請外籍看護照顧他。但是，去年橘子價格崩盤，家中經濟吃緊。溫金盛的父親74歲了，身上很多慢性病。這天外籍看護正在廚房忙著做飯，談起老闆忍不住落淚。她說溫金盛的父親最近住院，根本沒人到醫院照顧他，因為她得留在家裡照顧溫金盛。</p>
        <p>不捨父親的人生有三分之一都在照顧他跟奶奶，溫金盛曾試著跟父親談死亡，但是他立刻轉身離開，遑論提安樂死。溫金盛說：「他因為我，沒有自己的人生，我不想再繼續下去了。」</p>
      </template>
    </AppLightbox>
    <p>40歲的溫金盛活得痛苦孤寂，一直盼望能安樂死。</p>
    <p>16 歲那年，溫金盛因為騎車被計程車追撞造成全身癱瘓，24 年來，他大多時間只能躺在床上，唯一能跟外界溝通就是透過網路。多年臥床，他的肌肉萎縮，骨骼嚴重變形，心肺功能剩不到一半，清醒時，全身都在痛。他覺得自己什麼都得依賴人，無法做想做的事，每天只能追劇、上網，這樣活著根本沒有意義。更讓他愧疚的是，母親照顧他 10 年，因為過勞早逝；父親今年也 74 歲了，人生三分之一都在照顧失智症的奶奶和他，如今也全身是病。</p>
    <p>比利時聯邦監督評鑑委員會的一份報告記載了申請安樂死者面臨的各種痛苦，包括仰賴他人、失去獨立自主的能力、孤獨、絕望、喪失尊嚴與擔心失去與社會接觸的能力等，幾乎都是溫金盛目前面臨的處境，但是溫金盛卻不知道自己還要承受這些痛苦多久？他說：「癌末病人還可以預期死亡時間，但是像我這種脊髓損傷的，躺了 50 年的人都有，我不知道盡頭在哪，很可怕。安樂死是我的權利，我可以選擇，但是社會很多衛道人士覺得，『你還呼吸，就應該活著。』可是這些人了解我受的痛苦嗎？」</p>
    <AppLightbox :gaIndex="2" class="article__lightbox lazy">
      <template v-slot:lightboxImage>
        <img src="../assets/lightbox_btn_02.jpg" alt="韓治偉：我終於安穩地睡去" loading="lazy">
      </template>
      <template v-slot:lightboxTitle>
        <span>我終於安穩地睡去</span>
      </template>
      <template v-slot:lightboxSubtitle>
        <span>韓治偉</span>
      </template>
      <template v-slot:lightboxContent>
        <h2>韓治偉：我終於安穩地睡去</h2>
        <div class="lightbox__image">
          <img data-src="/projects/they-all-request-for-euthanasia/lightbox_02.jpg" src="" alt="韓治偉：我終於安穩地睡去">
          <p class="figcaption">韓媽媽慢慢清空韓治偉的東西。韓治偉給她最重要的都留在她心裡，她想帶著這些回憶，過好晚年生活，這也是韓治偉的心願。</p>
        </div>
        <p>2019 年初的一個週六，是韓森（化名）一家人來瑞士的第7天。在尊嚴協會（Dignitas）醫師再次了解哥哥韓治偉的病況以及兩次確認韓治偉執行安樂死的意願後，昨天告知，今天可以帶韓治偉過去執行了。1 月的瑞士正是冰雪天氣，韓森跟媽媽、姊姊推著坐在輪椅上的哥哥韓治偉走出飯店，帶著韓治偉在瑞士玩了幾天後，這真的是他最後一段路了，大家有點感傷。</p>
        <p>韓森擔心哥哥冷，快步走到哥哥面前，微微蹲下來拉緊哥哥的大衣問道，「有沒有開心？」從小就罹患腦性麻痹的韓治偉快 50 歲了，他吃力的動了動因為長年頸椎神經疾病導致癱瘓、攣縮的瘦弱身軀，扭曲臉龐對弟弟露出笑容。為了這一刻，韓治偉思考準備多年。韓森跟哥哥道別後，推著他走向前方 3 百多公尺的藍色房子，就在半年多前，體育主播傅達仁也在這裡結束生命。</p>
        <p>進屋後，韓治偉按著醫師跟中文翻譯的說明，努力地控制住手在安樂死同意書上一筆一畫歪歪扭扭的簽下英文姓名，再次確認自己想要執行安樂死的意願。為了簽名，在來瑞士前，韓治偉就一個字母一個字母的練習寫了數個月，但是他的身體狀況越來越差，來瑞士前 1 個多月，手已經無法按電視遙控器。全家很擔心如果韓治偉到時無法親自簽名，就算通過安樂死的綠燈，前往瑞士也無法執行。最後一刻，韓治偉終於順利簽下姓名。</p>
        <h3>「你放心，我不會硬留你。」</h3>
        <p>韓治偉蓋著一條紅毯子平躺著，媽媽依在他身邊說話。韓媽媽照顧韓治偉快 50 年了，很清楚治偉這些年所受的痛苦煎熬，也瞭解治偉一直把安樂死當成人生末期的選項之一。她幾年前就答應韓治偉，如果哪天他要走，「你放心，我不會硬留你。」這一刻終於來了，醫師將韓治偉身上注射的管子都準備妥當後，透過翻譯再次跟韓治偉確認執行安樂死的意願，韓治偉眼神堅定的點頭。家人原想開心地送韓治偉走，但是當看到韓治偉按下注射按鍵，忍不住背對他落淚，才不到幾秒就聽到韓治偉說著「我好睏⋯⋯」，藥進到韓治偉體內了，韓治偉已經平靜的走了。</p>
        <p>「他生下來 3 天就黃疸，發燒傷到大腦運動神經元，我陪他爬了 7 年，他才會走。20 年前，他因脊椎壓迫神經開刀失敗，全身癱瘓，完全喪失生活自理能力。這 20 年來，他每餐都要我餵，大小便要我幫忙，我照顧他整整 49 年，沒有一天睡好覺。他自己受苦受難累了，看我再過幾年就要 80 歲，他覺得我照顧他快 50 年，也夠了。他很怕我比他先走，所以選了這條路。」</p>
        <p>韓治偉走後 1 年，我們來到他北投家中採訪韓媽媽，她 77 歲了，仍然很有活力。</p>
        <p>北投家現在只剩韓媽媽一個人住。剛開始她一想起治偉就落淚，慢慢她打理陽台花草、出門上長青班、跟朋友、兒女吃飯，逐漸走出悲傷。治偉的東西都清理得差不多了，家中卻仍充滿著韓治偉留給母親的愛與回憶，韓治偉最愛的妹妹是一隻 6、7 歲的白色馬爾濟斯「妹妹」，此刻正坐在韓媽媽懷裡。牆上則是韓媽媽過去 20 年，旅行世界各國的照片，「我自己買菜燒飯，帶大3 個孩子。治偉覺得我照顧他，什麼娛樂都沒有，鼓勵我出國喘口氣。我真的很感謝他的貼心，跑過這麼多國家，我沒有遺憾了。」韓治偉覺得，母親的人生都在陪他，她也該有點出口，享受生活的美好，每次媽媽出國那幾天，就請臨時看護來家裡照顧他。</p>
        <h3>「我身心俱疲，不想再拖累家母。」</h3>
        <p>治偉的父親是牙醫，不了解也不知道怎麼對待韓治偉，只負責看診賺錢。韓治偉開刀失敗後，韓媽媽帶著他到振興醫院復健 10 年，韓治偉病情卻不斷惡化。韓治偉曾在他未出版的書稿裡寫道：「我一開始發病的時候，脖子只感覺麻麻的，到了中後期就開始一段毫無預警的像電到般，只有睡著才沒有感覺的痛苦日子⋯⋯可以說真的是體會了痛不欲生、終日與疼痛為伍的絕望感受，痛到我一度想去自殺。到最後，走路不穩、大小便開始失禁以及按遙控器無效等症狀一一浮現，我完全不知該怎麼自救。最了解我的家母都是到了後來，她自己受傷，才慢慢感同身受，10 多年來，我身心所承受的巨大痛苦。」</p>
        <p>母子老弱照顧，治偉也清楚母親不可能永遠這樣照顧他。某個農曆年，韓治偉想吃年糕，媽媽騎摩托車去市場買好回家，卻因停車時往後倒導致骨盆破裂，住院開刀換人工髖關節；也曾因細菌感染，鬼門關走一遭。母親兩次住院，嚇壞韓治偉，如果媽媽真的先走，他要怎麼辦？韓治偉更快馬加鞭完成書稿，他盼著台灣安樂死能合法，但是苦等未果。他在書稿後寫道：「我身心俱疲，而且實在不想再拖累家母了。」兩年前，看到傅達仁赴瑞士，他拜託曾經留美的弟弟幫他向瑞士尊嚴協會申請安樂死，姊姊也幫忙韓治偉寫英文自傳，媽媽則到醫院開立各科診斷書，找人翻譯、到法院公證，跑外交部辦證明。歷經 7 個多月，2018 年聖誕節這一天，韓治偉終於獲得瑞士尊嚴協會的首肯。</p>
        <p>2019 年 1 月 25日，韓治偉於瑞士面帶微笑結束充滿苦難的一生。</p>
      </template>
    </AppLightbox>
    <p>多年來，罹患腦性麻痺、重度癱瘓的韓治偉也寄望台灣安樂死能立法，讓他有條路好走。但是眼看自己身體惡化到連接受安樂死都快沒有能力了，又看到政府跟政治人物對於安樂死立法態度混沌不明，總是以再研議迴避問題，他轉而選擇跟隨傅達仁申請到瑞士安樂死。傅達仁死後半年，他也踏上死亡旅程。</p>
    <p>仔細翻閱韓治偉生前完成，但未曾出版的書稿，處處看到韓治偉跟生命的搏鬥。雖然從小就罹患腦性麻痺，但他努力學走路，認真學習，去大學跟博士班旁聽特殊教育跟心理學的課程。他也曾幻想是否有機會覓得佳人良緣，但是身體狀況的持續毀壞，他終於明白此生是無可能了。</p>
    <h3>還有多少像我這樣沒有尊嚴的病友，繼續維持這所謂生命徵象</h3>
    <p>他的書寫到身體無法再用電腦為止，討論台灣諸多長照悲歌個案以及對安樂死的看法，最後他覺得此生夠了，在家人支持下，在瑞士完成安穩睡去的夢想。但是如他的書稿所言，「還有多少像我這樣苟延殘喘，沒有尊嚴的病友們，拖著病體，對家人抱著內疚的心情，繼續維持著這毫無意義的所謂生命徵象？」</p>
    <p>的確，有多少人有韓治偉的經濟條件可以選擇到瑞士死亡呢？</p>
    <p>安樂死是「人到底有沒有自主死亡權利」的拔河。</p>
    <p>為維護憲法第十五條保障人的生存權，刑法有殺人罪專章，其中包括「加工自殺」跟「協助自殺」，都被認定觸犯「殺人罪」，最高刑期分別是 7 年和 5 年，都是重罪。最高法院庭長黃瑞華從此推論，「人如果有權自殺，別人幫助你就不是犯罪，這表示法律跟我們社會還是不允許自殺。」他認為，刑法不處罰自殺未遂是不忍處罰，不處罰自殺者是因為人已經死了，不表示人可以終結自己的生命。</p>
    <p>但擁有英國格拉斯哥大學醫學博士，曾在馬偕教導醫學倫理的江盛則認為，環顧整個西方歷史，雖然因為宗教的關係，一直不允許自殺，可是「人追求幸福，當這幸福受到疾病威脅時，我們還要聽那些不管是醫師，還是教會給你的神話嗎？還是我們要回來聽聽自己要什麼？死亡是人的自由跟權利，整個人類都在爭取這件事。」</p>
    <p>社會對自殺的污名，推動安樂死的團體一直「尊嚴善終」取代安樂死，認為安樂死是「喜樂再見」，與自殺不同。江盛卻有不同看法。他說：「傅達仁先生曾說，安樂死不是自殺，這種說法是閃避自殺的禁忌跟污名。請問安樂死不是自殺是什麼？」但是社會害怕面對自殺，一直難以好好討論這些問題。</p>
    <p>交大科技法律所所長陳鋕雄認為，在生命倫理問題前，涉及的都是人對自己要做的事，國家要不要去干涉的問題，「安樂死就像墮胎，涉及個人的基本權利，如果國家要干涉，就要負舉證責任，證明這樣的限制是一個適當手段。」</p>
    <p>檢視荷蘭跟瑞士相關法規，會發現荷蘭並沒有將生命自決權入法，而是將安樂死視為是醫師的醫療權，要醫師同意才能執行。瑞士為了不抵觸生命權的價值觀，並沒有將安樂死立法，而是改變刑法對協助殺人跟加工自殺的解釋，認為如果是「利他殺人」，不算犯罪，依此保護醫師合法執行安樂死的權利，免於被依殺人罪追究。</p>
    <img src="../assets/img_04.jpg" alt="傅達仁引發的安樂死討論，讓近年書市出現許多本相關翻譯書籍。" loading="lazy">
    <p class="figcaption">傅達仁引發的安樂死討論，讓近年書市出現許多本相關翻譯書籍。</p>
    <p>許毓仁所提安樂死草案，也不認為人有死亡的權利，而是讓法律賦予人請求死亡的權利，然後由醫師專業跟一套法律制度去決議，是不是可以安樂死。</p>
    <p>在傅達仁的案子裡，檢察官事後並沒有以刑法的「協助自殺」起訴幫助傅達仁赴瑞士的家人。江盛認為，檢察官是默認重症病患在必要時可以結束自己生命。對此，鄭貽說，他們無法猜測檢察官的想法，但是兩次赴瑞士前，都因為害怕被阻止，不敢告知任何人。甚至有記者質疑傅達仁怎麼不快點去死，是在刷純在感嗎？讓他們很無奈。鄭貽說：「事前我們就想過可能要負的法律責任，但是既然這是傅達仁的選擇，那就這樣吧，我們陪他一起承擔。」</p>
    <p>一位不願具名的檢察官受訪時分析，不追究傅家人，第一是依刑法的「屬地主義」原則，自殺及直接幫助自殺行為都在瑞士，家屬幫助到瑞士就醫屬間接行為，不必然構成自殺，在行為因果關係上有爭執空間。第二，依刑法屬人主義，在瑞士安樂死合法，我國對於傅達仁的家屬和瑞士醫護人員都沒有審判權。「當然，最主要的是，檢察官不會找自己麻煩，這種事情是個人選擇，又有價值理念的爭議，沒有必要主動攬在身上。」</p>
    <h2 id="part-4">「被安樂」就是被謀殺</h2>
    <h3>王敬熙案：探索「安樂死」和「殺人罪」的分界</h3>
    <p>關於「安樂死」和「殺人罪」的爭議，以及老老照護的問題，最具代表性的案件之一是民國 99 年 12 月的「王敬熙案」。</p>
    <p>當年 83 歲的王敬熙一直照顧著罹患帕金森氏症的太太王孫元，民國 99 年中秋，王孫元因為跌倒致髖骨骨折，更仰賴王敬熙。王敬熙看到太太深受病痛折磨，又無法自理日常起居，想起 20 多年前夫妻倆互有承諾，若對方已無生活自理能力，應了結其生命。26 日一早，王敬熙以事先收集的 4 顆俗稱 FM2 的管制安眠藥，騙太太是胃腸藥，等太太陷入昏睡，以鐵槌敲擊螺絲起子將釘子釘入太太顱內，造成太太神經性休克死亡。隨後，王敬熙致電警局自首。</p>
    <p>根據判決書，王敬熙在法庭上僅承認觸犯刑法殺人罪，但是認為自己沒有犯錯，「錯的是國家社會，因我國文化水準落後，沒有安樂死制度，必須讓病人痛苦的逝去，過於殘忍，若有安樂死制度，何須親手殺害妻子？」</p>
    <p>王敬熙主張安樂死，也曾在自己的部落格多次談論安樂死，但是他擔心太太害怕，後來都不敢跟太太提，「我要讓她在糊裡糊塗昏睡中就走了⋯⋯我沒有告訴她，她也沒有請我結束她的生命⋯⋯但是我們之前有承諾⋯⋯」。</p>
    <p>王敬熙一再對法官說，他們夫妻之前有承諾，而且安樂死像睡覺一樣就死掉了，沒有痛苦，太太也不痛苦。承審法官卻認為，這承諾距離當時太久，無從確認案發時王孫元仍維持此項承諾，而且王孫元當時意識清楚，可自主判斷，王敬熙卻未徵得太太是否有求死之意，即結束她的生命。</p>
    <p>一審法官引用過去判決認為，即便罹患重病或絕症而命在旦夕，都是刑法殺人罪所應保護之人，並無所謂沒有生存價值的生命。王敬熙未尊重王孫元決定自己生命走向之自由，不僅違反憲法保障生存權的意旨，也不符合刑法的加工自殺及協助自殺。</p>
    <p>對安樂死應否合法，法官認為這非本案審查範圍，而且這是個人自主權與生命權相衝突的社會倫理難題，應由民主程序決定，不適宜由普通法院逕自作出決定。王敬熙想用此案引起社會對安樂死的討論，無異於以他人作為手段，不尊重被害人生命價值。</p>
    <p>這案最大悲劇是王敬熙也沒有為妻子追求到安樂。審理過程，當王敬熙回憶起結束妻子生命過程，妻子曾喊痛時，情緒一再波動。法官認為，王敬熙心境無法平復，是因為他讓妻子在痛苦中結束生命。「顯然死者未能安寧往生，生者也無法獲得慰藉，相信本案被告使用的犯罪方法，與其所追求的安樂死理念，應有相當差距。」一審法官最後判決王敬熙殺人，處有期徒刑 9 年。</p>
    <img src="../assets/img_05.jpg" alt="生命的終局如何找到曙光？" loading="lazy">
    <p class="figcaption">生命的終局如何找到曙光？</p>
    <p>王敬熙後來上訴高等法院，當時高院合議庭庭長黃瑞華同情他，想為其減刑，王敬熙卻在宣判前3天因心臟衰竭病逝看守所。現在提起此案，目前是最高法院庭長的黃瑞華說：「這是照護人的崩潰，他也很可憐，他身心俱疲，承受經濟與倫理壓力，而且無力了，不得不選擇終止這件事。但是他太太不知情就非她本意，『被安樂』沒有安樂，就是殺人。」</p>
    <p>有人認為，在台灣需求安樂死的大多是欠缺長照資源的貧病弱者，這應該是去改善長照制度以及為末期病患增加更多安寧照護資源，而不是叫這群人去安樂死。很多人也擔心一旦通過安樂死立法，會不會導致多重殘障或貧病者失去無需在意家屬，自由表達希望治療，想活下來的環境？更多人甚至憂心，一旦安樂死立法通過會不會導致執法越來越寬鬆。</p>
    <p>溫金盛說他不擔心這個問題，因為安樂死申請有一定步驟，必須符合意願跟條件。他說：「如果他不願意，可以拒絕家人的要求。而且不是重症患者都會選擇這條路，關鍵還是活著有沒有意義，如果他覺得活得有意義，還有希望，他不會這樣做。」陳鋕雄則建議安樂死除了由醫師和病人決定，還可以加入司法機關，讓執行更到位。</p>
    <p>事實上，根據荷蘭對合法執行安樂死者的調查，相對於經濟弱勢族群，反而是佔有社會優勢以及對生活自主權要求比較高的族群死於安樂死的為多。美國奧勒岡州的研究也顯示，執行安樂死者，高學歷居多，代表並未發生貧困階級、少數民族、身心障礙等弱勢族群被迫接受安樂死的滑坡現象。</p>
    <p>即使身為最早合法化安樂死的荷蘭，也是多數醫師不贊成安樂死，家庭醫師有權拒絕病人的要求。根據台灣的《尊嚴善終法》草案，也是醫師有權拒絕。紀岳良說，「我們顧及醫師自主權，沒要求每個醫師一定要去做，只要有少數醫師願意幫忙就好，畢竟台灣需要安樂死的人不多。」</p>
    <h3>協助病人離開他不再適合居住的身體，也是醫師部分工作</h3>
    <p>江盛幾乎是唯一敢公開支持安樂死合法化的醫師，他引用哈佛大學教授、器官移植權威莫爾醫師的說法認為，「協助病人離開他不再適合居住的身體，也是醫師的部分工作。」</p>
    <p>觀察參與台北大學安樂死研討會的人士，很多都是嬰兒潮世代。這群 1946-1964 年出生，如今 56-74 歲的一代人，期待完全掌控自己的人生，當看到父母並沒有享受長壽所帶來的好處，接下來快輪到自己了，更容易思考安樂死的可能性。</p>
    <p>母親過世後，江盛開始思考「如果我處在我母親那個局面，我會希望兩個女兒怎麼做？」江盛大女兒在英國當醫師，二女兒正在波蘭唸醫學院，他說，如果是他要執行安樂死，他不會讓小孩去，因為這是自己的事，他不希望孩子處在他當時的局面。江盛說：「我照顧母親時有意願跟能力，但是我無法預測未來，我必須為我的死亡準備。」根據《尊嚴善終法》草案，安樂死不用經過親屬同意，對台灣人的生活倫理關係會是很大的挑戰。</p>
    <h2 id="part-5">獨老的現實</h2>
    <h3>把最壞的狀況都想過了，才能活的自在</h3>
    <AppLightbox :gaIndex="3" class="article__lightbox lazy">
      <template v-slot:lightboxImage>
        <img src="../assets/lightbox_btn_03.jpg" alt="張莉：我要找「自己的路」" loading="lazy">
      </template>
      <template v-slot:lightboxTitle>
        <span>我要找「自己的路」</span>
      </template>
      <template v-slot:lightboxSubtitle>
        <span>張莉</span>
      </template>
      <template v-slot:lightboxContent>
        <h2>張莉：我要找「自己的路」</h2>
        <div class="lightbox__image">
          <img data-src="/projects/they-all-request-for-euthanasia/lightbox_03.jpg" src="" alt="張莉：我要找「自己的路」">
          <p class="figcaption">鄰居黃明月（右）也獨居，這天陪著張莉出門走走。黃明月是佛教徒，理解張莉的選擇。她認為，當生命走到末期，選擇安樂死是希望更多人可以活得更好，這是自我犧牲，不叫殺生。</p>
        </div>
        <p>在汐止家中，每天一早起床，張莉第一件事就是先到客廳跟家人打招呼。</p>
        <p>說是「家人」，其實是家人的照片。電視櫃一角滿滿地放著住在美國的兩個女兒跟女婿、孫兒的全家福照，他們對她微笑著。她趨前跟我介紹過世多年的父母和剛過世的先生跟弟弟。那是她跟先生開心去洛磯山脈旅行的合照，弟弟的獨照看起來挺拔帥氣，怎知沒幾年，兩人都走了。</p>
        <p>「一起床就看到家人，感覺很溫暖，讓我覺得自己不是孤單的人。」獨居的張莉邊說邊拿出鄰居送的手工餅乾招待我。她說，大樓鄰居看她一個人住，常送食物給她，「鄰居都對我很好，可是再怎麼好也是我一個人在家裡。」同輩親友陸續離去，張莉在台灣只剩一個 80 多歲的姊姊，「我常跟我二姐說，你不能先走，你走我變孤兒。」</p>
        <p>兩年前，她摸到乳房有個硬塊，但是當時她忙著照顧中風跟失智症末期的先生，走不開，等到安撫好先生願意接受外籍看護照顧去醫院檢查，已是乳癌三期。先生過世後，她去開刀，看周圍罹患乳癌的朋友化療效果不好，她決定不化療。一年來，她定期追蹤，很感謝沒有復發。但是，她越來越擔心沒有能力照顧自己，考慮賣掉房子住進養生村，怎知養生村要求兩個直系血親當聯絡人，她被拒絕了。張莉沮喪的說，「我只想到二姐，可是她這麼老了，也不可能。我現在還可以管好我的錢跟生活，要吃什麼、做什麼，還可以。但是哪天我生病或失智了，我可以找誰來照顧我？」在台灣，住院、入住安養中心都需要聯絡人或保證人，許多老後單身的人身邊沒有親人，又因為這是很麻煩的事，不好意思請朋友幫忙，張莉真的很希望政府能出面幫忙他們解決這樣的問題。</p>
        <h3>做好死亡的心理準備</h3>
        <p>張莉更恐懼的是，未來乳癌復發所要面對的身體疼痛。「我知道乳癌第四期最容易轉移到骨頭，那是最痛的，而且會痛很久才走，我很害怕，我寧願安樂死，到時台灣如果合法，我就在台灣做，如果沒有，我就到美國做。所以那天我才會去參加安樂死研討會，很多事我都預先準備好，我會把最壞的都想好，這樣我才能活在當下，自由自在。」</p>
        <p>知道自己沒有靠山，張莉訓練自己獨當一面。先生走後，她一個人住院開刀同時換兩腳人工關節，知道出院沒人照顧，她趁著在醫院有請看護，很快下床復健。研討會這天，她開完刀才剛滿三個月，就一個人柱著拐杖來。「我只怕最後一段，我想要自己靠自己都沒有那個能力了。」</p>
        <p>張莉從沒想過晚年是這般光景。當年家境貧寒，她靠著努力讀書考上當時有「金飯碗」之稱的銀行員，她先生也有份不錯的工作，婚後兩人生了一對雙胞胎女兒。1996年台海危機，張莉先生擔心對岸會對台動武，決定移民美國。當時夫妻倆決定先生留在台灣工作，張莉辭職赴美陪伴兩個十歲的女兒。先生有空就到美國看他們。</p>
        <p>張莉在美國開咖啡廳，照顧女兒成年後，回臺灣陪伴先生。「我們不知道老了有很多問題，有些事你只能要求孩子，沒辦法要求別人替你做。」張莉的先生走前，甚至後悔當年移民。</p>
        <p>張莉喃唸著先生最後半年失智，整個人都亂了，帶給她很大的麻煩跟痛苦，但是慶幸的是，他走得平順安詳。她說：「我想像他這樣，但是我必須要自己先安排。我女兒在美國有工作跟家庭，不可能回台灣照顧我。」</p>
        <p>張莉很懂得過生活，她把家裡佈置的很舒適，看天氣好，還常常一個人出門去健行，找景色宜人的咖啡廳喝咖啡，但是她就是不斷地思考如何面對自己人生的最後階段。她說：「我甚至想過各種自殺方法，我不怕這些，我要找自己的路。」張莉堅持自己的生活方式，貫徹到後來的姿態，充滿韌性。</p>
      </template>
    </AppLightbox>
    <p>74 歲的獨居老人張莉（化名），從年輕工作，到移民美國，開咖啡廳養大兩個女兒，一直是個獨立自主，不喜歡麻煩別人的人。兩年前送走先生跟弟弟後，也開始思考怎麼面對自己的死亡。</p>
    <p>「我看到我先生走得很安詳，我想像他那樣，我不要像我弟那樣痛苦狼狽的死去。」張莉說，先生最後放棄維生醫療，在兩個女兒的陪伴下平靜過世，不像弟弟一直治療到最後一刻。她罹患乳癌三期，最怕未來癌細胞的轉移跟疼痛，所以她決定，如果癌症到第四期，她要安樂死。</p>
    <p>提起先生晚年中風，過世前半年又有嚴重失智症，張莉說，先生帶給她的是很大的麻煩跟痛楚，但是先生在她的照顧下走得很好，而她沒有這種條件。兩個女兒 10 歲就到美國，如今有各自的工作跟家庭，不可能回來照顧她。「所以我要事先安排，否則以後誰來照顧我？如果我也失智了，我要怎麼辦？所以我來參加安樂死研討會。」研討會這一天，張莉兩腳開人工關節才剛滿 3 個月，但她拄著拐杖一個人來。她說：「如果台灣安樂死合法，我就在台灣做，不行，我就到美國做。我會把最壞的狀況都想過，這樣我才能活在當下，自由自在。」</p>
    <p>夜深人靜，弟弟死前猙獰的呼喊經常浮現在張莉腦海，讓她淚濕衣襟。弟弟最後因為中風和糖尿病受盡醫院過度治療，全身體液滲滿整張床，曾痛苦到要求她：「張莉，拜託拜託啦，你拿個刀子來把我殺死好不好？」張莉哭了，弟弟連這種話都說出來，可見得有多痛苦，但是她卻只能回弟弟說，「我沒那麼笨，我殺了你，我還要坐牢。」</p>
    <p>她覺得死亡最可怕的是受盡折磨還走不掉，拖累自己，拖累家人。她提起去年一個癌末先生推著失智症太太去自殺，最後先生死亡，太太被救起的長照悲劇，「這就是因為台灣沒有安樂死，不然怎麼辦？有人就走不下去啊。另外，錢也是大問題，你說每個人都請得起外勞嗎？有人也付不起，整個家會垮掉。」張莉語氣突然很堅定的說，「所以我要找我自己的出路。」</p>
    <p>其實不管是安樂死，《預立緩和醫療條例》或是《病主法》，關乎的都是我們社會對死亡有多少討論。像荷蘭討論了 20 多年，才合法化安樂死。台灣又是如何？</p>
    <p>2017 年，台灣同志熱線聯盟調查一般民眾對安樂死的態度，高達九成人表達支持安樂死立法，也願意尊重所愛的人在如重症等合理理由下選擇安樂死，但是竟然只有 28% 跟 44% 的人知道《安寧緩和醫療條例》和《病主法》大致或詳細內容。即使最為人熟知的《預立放棄急救同意書》，也只有 58% 的人知道，顯示台灣民眾欠缺對這些生命議題的討論跟認識。</p>
    <p>在醫療發達的台灣，好死不容易，是時候該好好面對了。安樂死作為邁向生命終點的一種選擇，如紀岳良所說，「其實我們每個人都可能會需要安樂死，可是當我們真正意識到需要用時，往往已經沒有力氣講話。」死亡有千百種樣貌，需要有多元的管道去面對，未來的你會感謝現在的你關心這些問題。</p>
  </article>
</template>
<script>

import { throttle } from 'lodash'
import AppLightbox from './AppLightbox.vue'

export default {
  name: 'AppArticle',
  components: {
    AppLightbox
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: throttle(function () {
      const lazyLightboxs = [ ...document.querySelectorAll('.lazy') ]

      if (lazyLightboxs.length < 1) {
        return window.removeEventListener('scroll', this.handleScroll)
      }
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      lazyLightboxs.forEach((item, index) => {
        const rect = item.getBoundingClientRect()
        if (rect.top <= viewportHeight) {
          const lazyImg = item.querySelector('img[data-src]')
          lazyImg.setAttribute('src', lazyImg.getAttribute('data-src'))
          item.classList.remove('lazy')
        }
      })
    }, 300)
  }
}
</script>
<style lang="scss" scoped>
.app-article {
  width: 300px;
  margin: 0 auto;
  padding: 50px 0 40px;
  border-top: solid 1px #979797;
  @media (min-width: 768px) {
    width: 700px;
    padding: 0 0 62px;
    border-top: none;
  }
  @media (min-width: 1024px) {
    width: 700px;
    padding: 73px 0 62px;
    border-top: none;
  }
  > * {
    width: 266px;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 768px) {
      width: 634px;
    }
    & + * {
      margin-top: 30px;
    }
    & + p {
      margin-top: 40px;
    }
  }
  h2, h3 {
    font-weight: 900;
    font-family: source-han-serif-tc,serif;
  }
  h2 {
    font-size: 28px;
     @media (min-width: 1024px) {
      font-size: 30px;
    }
  }
  h3 {
    font-size: 18px;
    & + .article__lightbox {
      margin-top: 40px;
    }
  }
  p {
    text-align: justify;
    & + p {
      margin-top: 2em;
    }
    & + .article__lightbox {
      margin-top: 40px;
    }
    &.figcaption {
      padding-top: 10px;
      color: rgba(0, 0, 0, 0.66);
      font-size: 13px;
      line-height: 1.5;
      letter-spacing: 1px;
      border-top: solid 1px #979797;
    }
  }
  img {
    width: 100%;
    min-height: 100px;
    font-size: 13px;
    border-radius: 4px;
    & + p.figcaption {
      margin-top: 12px;
      @media (min-width: 1024px) {
        margin-top: 16px;
      }
    }
  }
  .article__lightbox {
    margin-top: 0;
    & + p {
      @media (min-width: 1024px) {
        margin-top: 2em;
      }
    }
  }
}
</style>
